import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import { down } from "styled-breakpoints"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons"
import styled from "styled-components"
import { list } from "../../../assets/data/pageStructure"
import { CardWrapperMob, Container } from "../../../utils/utils"
import { LinkedIn } from "../../../assets/images/svg/elements"

const Foot = styled.footer`
  background-color: ${props => props.bgColor || props.theme.color.prim1};
`

const FooterWrapper = styled(Container)`
  border-top: ${props => props.borderTop || "0px"} white solid;
  border-bottom: ${props => props.borderBottom || "0px"} white solid;
  margin: 0 auto;
  padding-top: 2rem;

  p,
  a {
    color: white;
  }

  a {
    white-space: pre-wrap;
  }
`

const FooterAdres = styled.div`
  ${down("xs")} {
    display: none;
  }
  p {
    :first-child {
      font-weight: 700;
    }
  }
`

const FooterKontakt = styled.div`
  text-align: center;
  a {
    font-weight: 700;
    transition: all 0.4s ease-in-out;

    :hover {
      font-weight: 900;
      color: ${({ theme }) => theme.color.base2};
    }
  }
  div {
    margin-top: 2rem;
    a {
      font-size: 30px;
      margin: 0 1rem;
    }
  }

  svg {
    fill: white;
    transition: all 0.4s ease-in-out;
    height: 40px;
    margin-top: 1rem;

    :hover {
      fill: ${({ theme }) => theme.color.base2};
    }
  }
`

const FooterLinki = styled.ul`
  text-align: right;
  list-style-type: none;
  line-height: 1;
  ${down("sm")} {
    display: none;
  }
  li {
    margin-bottom: 0.8rem;
  }
  a {
    font-weight: 400;
    line-height: 1;
    transition: all 0.4s ease-in-out;
    :hover {
      font-weight: 500;
      color: ${({ theme }) => theme.color.base2};
    }
  }
`

const Footer = ({ data, lang }) => {
  const menu = list.map(item => (
    <li key={item.name}>
      <Link activeClassName="active" to={item.path}>
        {lang === "en" ? item.nameEn : item.name}
      </Link>
    </li>
  ))

  const pl = data.pl
  const en = data.en
  const info = lang === "en" ? en : pl

  return (
    <Foot>
      <FooterWrapper>
        <CardWrapperMob xl="3" l="3" m="3" mb="0" pb="2rem">
          <FooterAdres>
            <p>{lang === "en" ? "Address" : "Adres"}</p>
            <p>
              {lang === "en"
                ? en.ulica + " " + en.nrBudnku + "street"
                : "ul. " + pl.ulica + " " + pl.nrBudnku}
            </p>
            <p>
              {info.kodPocztowy} {info.miasto}
            </p>
            <p>{info.wojew}</p>
            <p>{info.kraj}</p>
          </FooterAdres>

          <FooterKontakt>
            <Link to="/kontakt">{lang === "en" ? "Contact" : "Kontakt"}</Link>
            <p>+48 {info.telefon}</p>
            <p>{info.mail}</p>
            <a
              target="blank"
              href="https://www.linkedin.com/company/elcam-sp-z-o-o/"
            >
              <LinkedIn />
            </a>
            {/* <div>
              <a
                target="blank"
                href="https://www.facebook.com/MakijazPermanentnyMonikaGierczycka"
              >
                <FontAwesomeIcon icon={faFacebook} />
              </a>
              <a
                target="blank"
                href="https://www.facebook.com/MakijazPermanentnyMonikaGierczycka"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div> */}
          </FooterKontakt>

          <FooterLinki>{menu}</FooterLinki>
        </CardWrapperMob>
      </FooterWrapper>
    </Foot>
  )
}
export default function MyFooter(props) {
  return (
    <StaticQuery
      query={graphql`
        query {
          pl: datoCmsKontaktPage(locale: { eq: "pl-PL" }) {
            name
            ulica
            nrBudnku
            kodPocztowy
            miasto
            wojew
            kraj
            telefon
            mail
            locale
            slug
            fax
            nip
            krs
            regon
            kapital
            sad
            konto
          }
          en: datoCmsKontaktPage(locale: { eq: "en" }) {
            name
            ulica
            nrBudnku
            kodPocztowy
            miasto
            wojew
            kraj
            telefon
            mail
            locale
            slug
            fax
            nip
            krs
            regon
            kapital
            sad
            konto
          }
        }
      `}
      render={data => <Footer data={data} {...props} />}
    />
  )
}
